"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var STOP_LIVE_PLAYBACK = function () {
    return "mutation StopLinearPlayback($channelId: ID!, $deviceId: ID!) {\n    stopLinearPlayback(channelId: $channelId, deviceId: $deviceId)\n}";
};
exports.default = STOP_LIVE_PLAYBACK;
//# sourceMappingURL=stopLivePlaybackMetadata.js.map